import Record from './base'

export class Bid extends Record {
  constructor(...args) {
    super(...args)
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/bid.js